import React, { useState } from 'react';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { ReactComponent as ModalIcon } from 'assets/icons/video-circle.svg';
const TutorialModal = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  const TUTORIAL_ARRAY = [
    {
      id: 1,
      title: 'Create Surge',
      url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
    },
    {
      id: 2,
      title: 'Add Partner',
      url: ''
    },
    {
      id: 3,
      title: 'Delete Rider',
      url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
    },
    {
      id: 4,
      title: 'Delivery settings',
      url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
    }
  ];
  const [active, setActive] = useState(TUTORIAL_ARRAY[0]);

  return (
    <BaseModal
      isOpen={show}
      title=''
      titleIcon={<ModalIcon />}
      titleIconColor='info'
      onRequestClose={onClose}>
      <div className=' space-y-5'>
        <div className='w-full bg-[#f2f2f2] border border-red-5 rounded-[8px] h-[200px] md:h-[260px] flex justify-center items-center overflow-hidden'>
          <video className='min-w-[100%] min-h-[100%] rounded-[8px]' controls>
            <source src={active?.url} type='video/mp4' />
          </video>
        </div>
        <p className='text-center text-2xl font-semibold'>{active?.title}</p>
        <div className='flex flex-wrap items-center justify-center gap-3'>
          {TUTORIAL_ARRAY.map((item, i) => (
            <div
              key={i}
              onClick={() => setActive(item)}
              className={`w-4 transition-all h-4 rounded-full cursor-pointer  ${
                active?.id === item?.id ? 'bg-red-5' : 'bg-gray-9'
              }`}></div>
          ))}
        </div>
      </div>
    </BaseModal>
  );
};

export default TutorialModal;
